export default __webpack_public_path__ + "static/media/como-cadastrar-moca1.b8eeb229.svg";